export type HomeBreakpointKey = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export type WidgetZone = 'hero' | 'sidebar' | 'main';

export type WidgetVisibility = 'fixed' | 'hideable';

export type WidgetSizeProfile = 'card' | 'wide' | 'long';

export type WidgetColSpans = Partial<Record<HomeBreakpointKey, number>>;

export type WidgetLayoutProfile = {
  zone: WidgetZone;
  visibility: WidgetVisibility;
  sizeProfile: WidgetSizeProfile;
  colSpan: WidgetColSpans;
  order: number;
};

export type PlacedWidget = {
  id: string;
  zone: WidgetZone;
  col: number;
  row: number;
  colSpan: number;
};

export type WidgetRowLayout = {
  row: number;
  widgetIds: string[];
};

export type PackedMainLayout = {
  /** XL flex rows — widgets per row share space equally (3→33%, 2→50%). */
  widgetRows: WidgetRowLayout[];
  /** Flat placement for non-XL grid rendering. */
  gridPlacements: PlacedWidget[];
};

export const FIXED_WIDGET_IDS = new Set<string>([
  'home-greeting-widget',
  'home-switchrole-widget',
  'home-space-widget',
  'home-recent-updates-widget',
  'home-manage-widget',
]);

export const isFixedWidget = (widgetId: string): boolean =>
  FIXED_WIDGET_IDS.has(widgetId);

export const isHideableWidget = (widgetId: string): boolean =>
  !isFixedWidget(widgetId);
